import {
  curry,
  either,
  isEmpty,
  isNil,
  pathOr,
} from 'ramda';

export const isNilOrEmpty = either(isNil, isEmpty);

export const qualifyKeyPath = curry((domain, keyPath) => (isNilOrEmpty(keyPath)
  ? [domain, 'dev', 'null']
  : ['keySpaceManagers', domain, 'keySpace', ...keyPath]));

export const qualifyNewKeyPath = domain => ['keySpaceManagers', domain, 'newKey'];

export const getErrorMessage = pathOr('', ['error', 'message']);
